export default __webpack_public_path__ + "static/media/1111.235c0c79.jpg";